import React from 'react';
import { fmtDate } from '../../kit';

/**
 * What the People views share (backend: Backend/admin_people.py, section
 * "people"): the section name, the "e-mail these people" hand-off and the
 * relative dates the directory and the timeline show.
 */

export const PEOPLE = 'people';

/**
 * The hand-off to the campaign composer. People never mails anyone itself: it
 * announces the accounts, the Campaigns view listens for this event and the
 * Email Center switches to it.
 *   window event 'utech:email-people', detail { user_ids: string[] }
 */
export const EMAIL_PEOPLE_EVENT = 'utech:email-people';

export function emailPeople(userIds: string[], opts?: { template?: string | null; source?: string }) {
  const ids = Array.from(new Set(userIds.filter(Boolean)));
  if (!ids.length) return;
  // template (optional): preselect this template in the composer; source: who handed them over.
  window.dispatchEvent(new CustomEvent(EMAIL_PEOPLE_EVENT, {
    detail: { user_ids: ids, template: opts?.template || undefined, source: opts?.source || undefined } }));
}

/** An import the directory is narrowed to. */
export type SourceRef = { id: number; label: string };

/** Which person a timeline is for: an account, or any address at all. */
export type TimelineTarget = { email?: string; userId?: string };

const UNITS: Array<[number, string]> = [
  [365 * 86400, 'year'], [30 * 86400, 'month'], [7 * 86400, 'week'], [86400, 'day'], [3600, 'hour'], [60, 'minute'],
];

/** "3 days ago", "in 2 hours", "just now" — '' for no date. */
export const ago = (v: any): string => {
  if (v === null || v === undefined || v === '') return '';
  const t = new Date(v).getTime();
  if (Number.isNaN(t)) return '';
  const s = Math.round((Date.now() - t) / 1000);
  const abs = Math.abs(s);
  if (abs < 60) return 'just now';
  const [size, unit] = UNITS.find(([n]) => abs >= n) || UNITS[UNITS.length - 1];
  const n = Math.floor(abs / size);
  const word = `${n} ${unit}${n === 1 ? '' : 's'}`;
  return s >= 0 ? `${word} ago` : `in ${word}`;
};

/** A relative date with the exact one on hover. */
export const Ago: React.FC<{ value: any; empty?: string }> = ({ value, empty = '—' }) => {
  const rel = ago(value);
  if (!rel) return <span className="text-grayscale-1100">{empty}</span>;
  return <span title={fmtDate(value)}>{rel}</span>;
};

export const fmtDay = (v: any): string => {
  if (v === null || v === undefined || v === '') return '—';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v)
    : d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const num = (v: any) => Number(v ?? 0).toLocaleString();

/** Only http(s) links are rendered clickable: a URL in an event row is data
 *  from outside, and a javascript: one must not become a link. */
export const safeUrl = (u: any): string => (typeof u === 'string' && /^https?:\/\//i.test(u.trim()) ? u.trim() : '');
